// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V5wX","toggle":"styles_toggle__1q4kk","preview":"styles_preview__1Yf5t"};